import { Ng2StateDeclaration, Transition } from '@uirouter/angular';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { CategoriesService } from '../../shared/category/categories.service';
import * as fromPayrollItem from '.';
import { processResolver } from '../../efaact-routing/process-resolver';

const log = new LoggingService();

export const PayrollItemRoute: Ng2StateDeclaration = {
    // name: 'PayrollItem.**'
    name: 'payrollitemsetting',
    url: '/payrollitemsetting',
    // , loadChildren: () => import('./payroll-item.module').then(r => r.PayrollItemModule)
    data: { requiresAuth: true },
    params: { process: {} },
    resolve: [
        {
            token: 'process',
            deps: [Transition, CategoriesService],
            resolveFn: processResolver
        }
    ],
    component: fromPayrollItem.PayrollItemFeatureComponent
};
